import { useRef } from "react";
import { PaperclipIcon } from "lucide-react";

import { RESPONSIVE_ICON_BUTTON_CLASS } from "../../lib/touchTarget";
import { cn } from "../../lib/utils";
import { Button } from "../ui/button";
import { Tooltip, TooltipPopup, TooltipTrigger } from "../ui/tooltip";

interface ComposerImageAttachmentButtonProps {
  readonly disabled: boolean;
  readonly onFilesSelected: (files: ReadonlyArray<File>) => void;
}

export function ComposerImageAttachmentButton(props: ComposerImageAttachmentButtonProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept="image/*,.pdf,.txt,.md,.json,.csv,.doc,.docx,.xls,.xlsx,.zip"
        multiple
        className="hidden"
        tabIndex={-1}
        aria-hidden="true"
        onChange={(event) => {
          const files = Array.from(event.currentTarget.files ?? []);
          event.currentTarget.value = "";
          props.onFilesSelected(files);
        }}
      />
      <Tooltip>
        <TooltipTrigger
          render={
            <Button
              type="button"
              variant="ghost"
              size="icon-sm"
              className={cn(RESPONSIVE_ICON_BUTTON_CLASS, "rounded-full md:size-8")}
              disabled={props.disabled}
              onPointerDown={(event) => event.preventDefault()}
              onClick={() => inputRef.current?.click()}
              aria-label="Attach files"
            />
          }
        >
          <PaperclipIcon />
        </TooltipTrigger>
        <TooltipPopup>Attach files</TooltipPopup>
      </Tooltip>
    </>
  );
}
